import {MatPaginatorModule, MatPaginatorIntl} from '@angular/material/paginator';

export class MatPaginatorIntlof extends MatPaginatorIntl{
    getRangeLabel = function (page, pageSize, length) {
        if (length === 0 || pageSize === 0) {
          return '0 sur ' + length;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
          Math.min(startIndex + pageSize, length) :
          startIndex + pageSize;
          const lang = localStorage.getItem('lang');

          if (lang == 'fr') {
            return startIndex + 1 + ' - ' + endIndex + ' sur ' + length;

          } else if(lang == 'gb') {
            return startIndex + 1 + ' - ' + endIndex + ' out of ' + length;

      
          }

      }; 
}

export function CustomPaginator(){
  const customPaginatorIntl = new MatPaginatorIntlof();
  const lang = localStorage.getItem('lang');


    if (lang == 'fr') {
      customPaginatorIntl.itemsPerPageLabel = 'Nombre d\'éléments par page:';
    } else if(lang == 'gb') {
      customPaginatorIntl.itemsPerPageLabel = 'Items per page:';
    }

  return customPaginatorIntl;
}
